import { SliderProps } from 'ui/components/3-organisms/Slider/Slider';
import dynamic from 'next/dynamic';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';

interface Props {
	documentType: 'slider';
	content: {
		properties: {
			slides: {
				content: {
					properties: {
						kicker: string;
						altText: string;
						heading: string;
						text: string;
						link: Content.Link | null;
						image: Content.Image | null;
					};
				};
				settings: {
					properties: {
						displayLinkAsButton: boolean;
						orientation: Content.Orientation;
						imageCropping: Content.ImageCropping;
					};
				};
			}[];
		};
	};
}

/**
 * Swiper is a large dependency used only on a few select pages
 * so we opt to load it dynamically with next/dynamic
 */
const DynamicSlider = dynamic<SliderProps>(() => import('ui/components/3-organisms/Slider/Slider').then((module) => module.UI_Slider), {
	// ssr: false,
});

export const Slider = ({ content }: Props) => {
	const { slides } = content?.properties ?? {};
	const dictionary = useDictionaryContext();
	const prevSlideTitle = dictionary.getLabel('PrevSlide');
	const nextSlideTitle = dictionary.getLabel('NextSlide');

	const mappedSlides = slides.map(({ content, settings }) => {
		const { kicker, altText, heading, text, link, image } = content?.properties ?? {};
		const { displayLinkAsButton, imageCropping, orientation } = settings?.properties ?? {};

		return {
			kicker,
			altText,
			heading,
			text,
			link,
			image,
			displayLinkAs: (displayLinkAsButton ? 'button' : 'arrowLink') as 'button' | 'arrowLink',
			imageCropping,
			orientation,
		};
	});

	return <DynamicSlider slides={mappedSlides} prevSlideTitle={prevSlideTitle} nextSlideTitle={nextSlideTitle} />;
};
